export const BROWN = "Brown";
export const UNIVERS = "Univers";
export const CHISWICK = "Chiswick";

export const BASE_FONT_SIZE = 20;
export const MIN_FONT_SIZE = 16;
export const MAX_FONT_SIZE = 24;

export const VIEWPORT_WIDTH_FONT_SIZE = 1.2;

export const BODY = {
  fontFamily: `${UNIVERS}, Helvetica, Arial, sans-serif`,
  fontSize: '1rem',
  fontWeight: 'normal',
  lineHeight: 1.42,
  letterSpacing: '0.02em',
  textAlign: 'left',
};

export const BODY__BOLD= {
  ...BODY,
  fontWeight: 'bold',
};

export const BODY__SMALL = {
  ...BODY,
  fontSize: `${15/BASE_FONT_SIZE}rem`,
  lineHeight: 1.4,
  letterSpacing: 0.13,
};

export const BODY__SMALL__BOLD = {
  ...BODY__BOLD,
  fontSize: `${15/BASE_FONT_SIZE}rem`,
  lineHeight: 1.3,
  letterSpacing: 0.13,
  //fontFamily: `${CHISWICK}, serif`,
  fontWeight: 'bold',
};

export const HEADING = {
  fontFamily: `${CHISWICK}, serif`,
  fontSize: `${100/BASE_FONT_SIZE}rem`,
  fontWeight: 'normal',
  lineHeight: 1,
  letterSpacing: 0,
  textAlign: 'center',
};

export const HEADING_MOBILE = {
  ...HEADING,
  fontSize: `${73/BASE_FONT_SIZE}rem`,
};

export const HEADING_TABLET = {
  ...HEADING,
  fontSize: `${68/BASE_FONT_SIZE}rem`,
};

export const SUB_HEADING = {
  ...BODY__BOLD,
  fontSize: `${23/BASE_FONT_SIZE}rem`,
  lineHeight: 1.2,
  letterSpacing: 0,
};

export const SUB_HEADING_MOBILE = {
  ...BODY__BOLD,
  fontSize: `${16/BASE_FONT_SIZE}rem`,
  lineHeight: 1.2,
  letterSpacing: 0,
};

export const SUBSUB_HEADING = {
  ...BODY__BOLD,
};



// WEBPACK FOOTER //
// ./src/theme/typography.js